// Module panier partagé (page produit, tiroir panier, barre d'achat fixe).
// - Toutes les écritures passent par ici, puis « mp:panier:maj » est émis avec le panier à jour.
// - Règles des options payantes (protection, traitement prioritaire) :
//   quantité 1 maximum, et retrait automatique s'il ne reste aucun autre article.
//
// Configuration lue dans window.mpConfig (layout/theme.liquid) : { racine, options: [product_id…] }
(() => {
  if (window.MpPanier) return;

  const config = window.mpConfig || {};
  const racine = config.racine || '/';
  const idsOptions = (config.options || []).map(Number);

  const requete = async (chemin, corps) => {
    const reponse = await fetch(`${racine}${chemin}`, {
      method: corps ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: corps ? JSON.stringify(corps) : undefined,
    });
    const donnees = await reponse.json();
    if (!reponse.ok) throw new Error(donnees.description || donnees.message || reponse.statusText);
    return donnees;
  };

  const MpPanier = {
    estOption(article) {
      return idsOptions.includes(Number(article.product_id));
    },

    articlePrincipalPresent(panier) {
      return panier.items.some((article) => !this.estOption(article));
    },

    trouverVariante(panier, variantId) {
      return panier.items.find((article) => Number(article.variant_id) === Number(variantId));
    },

    async obtenir() {
      return requete('cart.js');
    },

    // articles : [{ id, quantity, properties? }]
    async ajouter(articles) {
      await requete('cart/add.js', { items: articles });
      return this.finaliser();
    },

    // Modifie une ligne par sa clé (quantité 0 = suppression)
    async changer(cle, quantite) {
      await requete('cart/change.js', { id: cle, quantity: quantite });
      return this.finaliser();
    },

    async retirerVariante(variantId) {
      const panier = await this.obtenir();
      const article = this.trouverVariante(panier, variantId);
      if (!article) return panier;
      return this.changer(article.key, 0);
    },

    // Applique les règles des options puis publie le panier
    async finaliser() {
      let panier = await this.obtenir();
      const corrections = {};

      panier.items.forEach((article) => {
        if (!this.estOption(article)) return;
        if (!this.articlePrincipalPresent(panier)) corrections[article.key] = 0;
        else if (article.quantity > 1) corrections[article.key] = 1;
      });

      if (Object.keys(corrections).length > 0) {
        panier = await requete('cart/update.js', { updates: corrections });
      }

      this.publier(panier);
      return panier;
    },

    publier(panier) {
      document.dispatchEvent(
        new CustomEvent('mp:panier:maj', { detail: { item_count: panier.item_count, panier } })
      );
    },
  };

  window.MpPanier = MpPanier;

  // Signalé par Liquid : le panier ne contient plus que des options payantes
  if (config.nettoyerOptions) MpPanier.finaliser().catch(() => {});
})();
